import environment from "../environment";

export const getAssetUrl = (item: string): string => {
  return `${environment.REACT_APP_ASSETS_ENDPOINT}/sdk/${item}`;
}

export const days = ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"];
